import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "basic_salary",
    type: "money",
    sortable: true,
    searchable: true,
  },
  {
    name: "allowed_late_minutes",
    type: "number",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="grades" columns={columns} />;
}
